import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchStockIssueDetail(id) {
  const { data: raw } = await request.get(`/ims/stock-issue/${id}`);
  return parseVer4DetailResponse(raw);
}
